import {showMagnetBtn} from "../common/help_functions";

(function ($) {

    $(document).ready(function () {

        $('.section-multi-slider').each(function () {
            showMagnetBtn('.multi-slider-btn')

            let target = $(this)

            target.viewportChecker({
                classToAdd: 'visible',
                repeat: true
            });

            let currentIndex_slider = -1
            let panel = target.find(".panel")
            let timer = 10000
            let progressBar = target.find(".progress_line")

            run();

            $(document).on('click', '.showPanel', function () {
                showPanel($(this).attr('data-slider-panel'));
            });

            function run() {
                progressBar.width(0);
                showPanel(currentIndex_slider + 1);

                if ($(window).width() > 991) {
                    progressBar.animate({'width': "+=330px"}, timer, run);
                } else {
                    progressBar.animate({'width': "+=100%"}, timer, run);
                }
            }

            function showPanel(index) {
                panel.eq(currentIndex_slider).fadeOut("slow", function () {
                    panel.eq(currentIndex_slider).stop(true, true);
                    panel.eq(currentIndex_slider).removeClass('currentslider');
                    currentIndex_slider = index;

                    if (currentIndex_slider < 0) {
                        currentIndex_slider = panel.length - 1;
                    } else if (currentIndex_slider >= panel.length) {
                        currentIndex_slider = 0;
                    }

                    panel.eq(currentIndex_slider).stop(true, true).fadeIn("slow");
                    panel.eq(currentIndex_slider).addClass('currentslider');

                    target.find(".slider-left .nav-titles ul li").removeClass('current').eq(currentIndex_slider).addClass('current');

                    target.find(".slider-left .slider-text .line .showPanel").each(function () {
                        $(this).removeClass('current');
                    });

                    target.find(".slider-left .currentslider .slider-text .line .showPanel").removeClass('current').eq(currentIndex_slider).addClass('current');
                });
            }

            $(window).on("scroll", function () {
                if (target.hasClass("visible") && $(window).width() > 991) {
                    parallaxBigText();
                }
            });

            $(window).resize(function () {
                if ($(window).width() > 991) {
                    parallaxBigText();
                } else {
                    target.find(".text-big").css('transform', 'translateX(10%)');
                }
            });

            function parallaxBigText() {
                let scrolled = $(window).scrollTop();

                if(target.index() > 1) {
                    scrolled = scrolled - target.innerHeight() * (target.index() - 1)
                }

                if (target.hasClass("visible") ) {
                    if(scrolled > 0) {
                        if(target.index() > 1) {
                            target.find(".text-big").css('transform', 'translateX(' + scrolled / 18 + '%)');
                        } else {
                            target.find(".text-big").css('transform', 'translateX(' + scrolled / 6 + '%)');
                        }
                    } else {
                        target.find(".text-big").css('transform', 'translateX(' + (0) + '%)');
                    }
                } else {
                    target.find(".text-big").css('transform', 'translateX(' + (0) + '%)');
                }
            }

        })
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/section_multi_slider.js